import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterOutlet } from '@angular/router';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [CommonModule, RouterOutlet, RouterLink],
	template: `
	<div *ngIf="showSplash" class="splash d-flex flex-column align-items-center justify-content-center">
		<div class="splash-card text-center animate-fade-in">
			<img src="assets/images/logocbl.png" alt="Logo" class="splash-logo animate-pop animate-float" width="200" height="200" decoding="async" fetchpriority="high" />
			<h1 class="splash-title mt-3">منظومة أرباب الأسر</h1>
			<h2 class="splash-subtitle">نظام الترجيع</h2>
			<div class="splash-subtitle small mt-1 text-muted">بتصميم إدارة أمن المعلومات</div>
			<div class="row g-3 mt-4">
				<div class="col-12 col-md-6">
					<button class="btn btn-success btn-lg w-100" (click)="enterNewCase()">
						<i class="bi bi-plus-circle"></i> إضافة حالة جديدة
					</button>
				</div>
				<div class="col-12 col-md-6">
					<button class="btn btn-outline-primary btn-lg w-100" (click)="enterSearch()">
						<i class="bi bi-search"></i> البحث عن حالة
					</button>
				</div>
				<div class="col-12">
					<a class="btn btn-link text-muted" href="#" (click)="$event.preventDefault(); enterNewCase();">
						تخطي والانتقال مباشرة
					</a>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="!showSplash">
		<nav class="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm sticky-top mb-4">
			<div class="container-fluid">
				<span class="navbar-brand d-flex align-items-center gap-2">
					<i class="bi bi-bank2 me-2"></i>
					<span class="brand-title">مصرف ليبيا المركزي - مشروع أرباب الأسر</span>
				</span>
				<div class="ms-auto d-flex gap-2">
					<a class="btn btn-sm btn-outline-light" [routerLink]="['/']">حالة جديدة</a>
					<a class="btn btn-sm btn-outline-light" [routerLink]="['/search']">بحث</a>
				</div>
			</div>
		</nav>
		<div class="container mb-5 animate-fade-in">
			<router-outlet />
		</div>
		<footer class="app-footer navbar-dark bg-dark py-3 mt-auto shadow-sm">
			<div class="container d-flex justify-content-between align-items-center">
				<span class="footer-text small">© مصرف ليبيا المركزي</span>
				<span class="footer-text small">إدارة أمن المعلومات</span>
			</div>
		</footer>
	</div>
	`
})
export class AppComponent {
	showSplash = true;
	constructor(private router: Router) {}
	enterNewCase() { this.showSplash = false; this.router.navigateByUrl('/'); }
	enterSearch() { this.showSplash = false; this.router.navigateByUrl('/search'); }
}


